export const API_BASE = {
	USER_SEARCH: '/workflow/user/suggest/',
	WORKFLOW_GROUP_DETAILS: '/workflow/group/details',
	WORKFLOW_GROUP_SAVE: '/workflow/group/save/',
	WORKFLOW_GROUP_REMOVE: '/workflow/group/remove/',
	WORKFLOW_GROUPS_LIST: '/workflow/group/list',
};
